var React = require('react');

function SinglePatternInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"pattern","d":"M799.411 0L0 233.692L199.139 408.757","fill":"#132F34"}));
}

SinglePatternInline.defaultProps = {"width":"471","height":"409","viewBox":"0 0 471 409","fill":"none"};

module.exports = SinglePatternInline;

SinglePatternInline.default = SinglePatternInline;
